import React from 'react';

export const BreadcrumbContext = React.createContext({});
